// extracted by mini-css-extract-plugin
module.exports = {"bubbles":"styles_bubbles__3ZVnT","bubbleHolder":"styles_bubbleHolder__1-HV9"};